import React, { memo } from 'react';
import {
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
  LoadingButton,
  Icon
} from 'investira.react.components';
import AvalicoesSaveStatus from '../_components/AvalicoesSaveStatus';
import AvaliacoesProgresso from '../_components/AvaliacoesProgresso';
import SessaoNavProgress from '../_components/SessaoNavProgress';
import AvaliacoesGestorEditQuestoes from './AvaliacoesGestorEditQuestoes';
import AvaliacoesGestorEditAnexosPanel from './AvaliacoesGestorEditAnexosPanel';

const AvaliacoesGestorEditQuestionarioView = memo(props => {
  const { questionario, anexos, actions, disabledButtons, fluxoAcaoEmAndamento } = props;

  return (
    <Stack direction="row" gap={6}>
      <Stack
        id="sessoes"
        direction="column"
        gap={2}
        sx={{
          position: 'sticky',
          top: 24,
          alignSelf: 'flex-start',
          maxHeight: 'calc(100vh - 24px)',
          overflowY: 'auto',
          minWidth: '340px',
          maxWidth: '340px',
          width: '100%'
        }}>
        <AvaliacoesProgresso
          variant="gestor"
          qtdQuestoes={questionario.questoesTotal}
          respondidas={questionario.respondidas}
        />
        <Divider />
        <SessaoNavProgress
          sessoes={questionario.sessoesProgress}
          activeCategoryId={questionario.activeCategoryId}
          onClick={actions.handleSelectCategoria}
        />
        <Divider />
        <LoadingButton
          variant="contained"
          color="primary"
          startIcon={<Icon iconName="paper_plane" size={16} />}
          size="small"
          sx={{ px: 2 }}
          data-testid="abrir-assinatura-entrega"
          onClick={actions.handleOpenAssinaturaDialog}
          disabled={!questionario.todasRespondidas || disabledButtons || fluxoAcaoEmAndamento}>
          Entregar
        </LoadingButton>
      </Stack>

      <Stack direction="column" flexGrow="1" gap={2}>
        <Stack direction="row" justifyContent="space-between">
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={questionario.mostrarApenasNaoRespondidas}
                onChange={pEvent => actions.setMostrarApenasNaoRespondidas(pEvent.target.checked)}
              />
            }
            label={
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Apenas não respondidas
              </Typography>
            }
          />
          <AvalicoesSaveStatus
            modified={questionario.avaliacao?.modified}
            saving={questionario.avaliacaoSalvando}
          />
        </Stack>
        <Divider />
        <AvaliacoesGestorEditQuestoes
          sessoes={questionario.sessoes}
          sessoesQuestoes={questionario.sessoesQuestoes}
          activeCategoryId={questionario.activeCategoryId}
          activeQuestionId={questionario.activeQuestionId}
          onSelect={actions.handleChangeActiveQuestionId}
          respostas={questionario.respostas}
          onQuestionChange={actions.handleQuestionChange}
          mostrarApenasNaoRespondidas={questionario.mostrarApenasNaoRespondidas}
        />
      </Stack>

      <Stack gap={2}>
        <AvaliacoesGestorEditAnexosPanel
          anexos={anexos}
          disabledButtons={disabledButtons}
          fluxoAcaoEmAndamento={fluxoAcaoEmAndamento}
          todasRespondidas={questionario.todasRespondidas}
          onOpenAnexos={actions.handleOpenAnexos}
          onAddAnexos={actions.handleAddAnexos}
          onToggleGrupoQuestao={actions.handleToggleGrupoQuestao}
          onOpenRemoveAnexoDialog={actions.handleOpenRemoveAnexoDialog}
          onOpenAssinaturaDialog={actions.handleOpenAssinaturaDialog}
        />
      </Stack>
    </Stack>
  );
});

export default AvaliacoesGestorEditQuestionarioView;
